












































































































import { defineComponent, computed, h, getCurrentInstance } from '@vue/composition-api';
import dayjs from 'dayjs';

import { getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import { i18n_t } from '@/locales/i18n';
import { dayjsUsage } from '@/renderer/scripts/utils/dayjsUsage';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import ipc from '@/renderer/scripts/utils/ipc';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { operatorMap } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
export default defineComponent({
  name: 'dynamicItem',
  props: {
    dynamicItems: {
      type: Object,
      default: () => null,
    },
    isWorkbench: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { dynamicItems } = props;
    const routerName = context.root.$route.name;
    const TimeTrans = (time: string): string => {
      const date = new Date(dayjs(time).valueOf() + 8 * 3600 * 1000);
      const res = date.toJSON()?.substring(0, 19).replace('T', ' ');
      return res?.split(' ')[1].slice(0, -3);
    };
    const modifyTime = (time: string): string => {
      const todayTime = dayjsUsage('day').endTime.split(' ')[0];
      const yesterdayTime = dayjsUsage('yesterday').startTime.split(' ')[0];
      if (time >= todayTime) {
        return i18n_t('今天');
      }
      if (time >= yesterdayTime && time <= todayTime) {
        return i18n_t('昨天');
      }
      return time?.slice(-5);
    };
    const timeNode = computed(() => modifyTime(dynamicItems.date));
    // 普通的动态数据处理
    const dynamics = computed(() => {
      if (routerName === 'workbench') return [];
      dynamicItems.list.forEach((item: any) => {
        item.actionName = operatorMap.get(item.actionTypeDetail);
        // 只拿取时间到分钟
        item.operationTime = TimeTrans(item.operationTime);
      });
      return dynamicItems.list;
    });
    const workbenchDynamic = computed(() => {
      if (routerName !== 'workbench') return [];
      let tag = '';
      dynamicItems.list.map((item: any) => {
        item.details.forEach((cur: any) => {
          if (cur?.team) {
            tag = i18n_t('企业');
          } else if (cur?.group) {
            tag = i18n_t('协作');
          }
          cur.actionName = operatorMap.get(cur.actionTypeDetail);
          cur.operationTime = TimeTrans(cur.operationTime);
        });
        item.tag = tag;
        return item;
      });
      return dynamicItems.list;
    });
    const methods = {
      operationFileOrDir(item: SMH.DynamicData) {
        // 无法知道item在文件夹中的页码
        ipc.emit(ipc.RENDERER_EVENTS_MAP.DRAWER_DYNAMIC_OPEN, {
          ...item,
        });
      },
      routeToTeamSpace(item: SMH.WorkData) {
        // 跳转到企业板块功能
        if (item.details[0] && item.details[0].team) {
          // 路由到工作空间
          const { spaceId, id: teamId, name: path, path: teamPath } = item.details[0].team;
          dispatchRouter({
            name: 'teamSpace',
            query: {
              spaceId,
              teamId: String(teamId),
              teamPath: teamPath?.join('/') || path,
              path: '',
            },
          });
        }
      },
    };
    return { dynamics, timeNode, workbenchDynamic, ...methods, getNameTipsDetail };
  },
});
